<template>
  <v-dialog v-model="isShown" :max-width="width" persistent>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>

      <div class="pa-4">
        <v-row class="mx-2" align="center">
          <AppFormSelect
            label="البحث عبر "
            :items="searchTypes"
            v-model="employee.searchTypeId"
            rules="required"
            @change="changeType"
          />
          <AppFormSelect
            clearable
            label="نوع الادارة "
            :items="administrationTypes"
            v-model="employee.administrationTypeId"
            rules="required"
            @change="changeType"
            v-if="employee.searchTypeId == 2"
          />
        </v-row>
        <v-row class="mx-2" align="center">
          <template v-if="employee.searchTypeId == 2">
            <AppFormSelect
              clearable
              label=" الادارة / الفرع "
              :items="admins"
              v-model="employee.administrationId"
              rules="required"
              @change="changeAdministration"
            />
            <AppFormSelect
              clearable
              label="القسم"
              :items="departments"
              v-model="employee.departmentId"
              rules=""
              @change="getUnits"
            />
            <AppFormSelect
              clearable
              label="الوحدة"
              :items="units"
              v-model="employee.unitId"
              rules=""
              @change="getInfo"
            />
            <AppFormSelect
              clearable
              label="الموظفين"
              :items="employeesList"
              v-model="employee.employeeId"
              rules="required"
            />
          </template>

          <template v-if="employee.searchTypeId == 1">
            <AppFormField
              label="   الرقم التسلسلي"
              v-model="employee.employmentNo"
            />
            <v-col cols="1" class="ml-5">
              <v-btn @click="search" depressed color="primary">بحث</v-btn>
            </v-col>

            <AppReadonlyField
              clearable
              label="الاسم بالكامل"
              :value="employee.fullName"
              v-if="hasResult"
            />
          </template>
        </v-row>
      </div>
      <v-card-actions class="justify-end">
        <v-btn small text @click="cancel">إلغاء</v-btn>
        <v-btn small color="error" @click="confirm" :disabled="!hasResult"
          >تأكيد</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    width: {
      default: "850px",
    },
    isShown: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    employee: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.$store.dispatch("lookups/getLookups");
    this.$store.dispatch("lookups/getAdministrations");
  },
  computed: {
    administrationTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.AdministrationTypes
      );
    },
    admins() {
      return this.$store.state.lookups.administrations;
    },
    departments() {
      return this.$store.state.lookups.departments;
    },
    units() {
      return this.$store.state.lookups.units;
    },
    searchTypes() {
      return [
        { value: 1, label: "الرقم التسلسلي" },
        { value: 2, label: "الادارة/القسم" },
      ];
    },
  },
  data() {
    return {
      hasResult: false,
      employeesList: [],
    };
  },
  methods: {
    search() {
      if (
        this.employee.employmentNo != null &&
        this.employee.employmentNo != ""
      ) {
        this.$store
          .dispatch("lookups/employeesSearch", this.employee.employmentNo)
          .then((res) => {
            this.employee.employeeId = res.value;
            this.employee.fullName = res.label;
            this.hasResult = true;
          })
          .catch(() => {
            this.employee.employeeId = null;
            this.employee.fullName = null;
            this.hasResult = false;
          });
      }
    },

    changeAdministration() {
      this.employee.departmentId = null;
      this.employee.unitId = null;

      let administration = this.admins.find((x) => {
        return x.value == this.employee.administrationId;
      });
      console.log(administration);
      if (administration.type != 1002) {
        this.$store.dispatch(
          "lookups/getDepartments",
          this.employee.administrationId
        );
      } else {
        this.$store.dispatch("lookups/getUnitsById", {
          typeId: 1,
          id: this.employee.administrationId,
        });
      }
      this.getEmployees();
    },
    getUnits() {
      this.employee.unitId = null;
      this.$store.dispatch("lookups/getUnitsById", {
        typeId: 2,
        id: this.employee.departmentId,
      });
      this.getEmployees();
    },
    getInfo() {
      this.getEmployees();
      // this.getDepartments();
    },
    // getDepartments() {
    //     this.$store.dispatch("lookups/getDepartments", this.employee.administrationId);

    // },
    getEmployees() {
        console.log(this.employee.departmentId);
      this.employeesList = [];
      let params = {
        type:
          (this.employee.administrationId > 0 &&  this.employee.departmentId == null && this.employee.departmentId == null)
            ? 11001
            : (this.employee.departmentId > 0 && this.employee.unitId == null)
            ? 11002
            : 11003,
        id:
          this.employee.administrationId > 0
            ? this.employee.administrationId
            : this.employee.departmentId > 0
            ? this.employee.departmentId
            : this.employee.unitId,
      };
      this.$store
        .dispatch("lookups/getManagementEmployees", params)
        .then((res) => {
          this.employeesList = res.employees;
        })
        .catch(() => {});
    },
    changeType() {
      this.$store.dispatch(
        "lookups/getAdministrationsByType",
        this.employee.administrationTypeId
      );
    },
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>